"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _TypeAhead = _interopRequireDefault(require("./TypeAhead"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "typeahead": "DefaultTheme__typeahead___2kSaS"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "typeahead": "DarkTheme__typeahead___yEgZz"
};
require("../Select/themes/DefaultTheme.css");
var SelectDefaultTheme = {
  "select": "DefaultTheme__select___1qBDv",
  "select-control": "DefaultTheme__select-control___1Pnw3",
  "has-error": "DefaultTheme__has-error___2pDW6",
  "is-searchable": "DefaultTheme__is-searchable___3iaJ3",
  "is-open": "DefaultTheme__is-open___3xj30",
  "is-disabled": "DefaultTheme__is-disabled___31xF1",
  "select-placeholder": "DefaultTheme__select-placeholder___IC546",
  "has-value": "DefaultTheme__has-value___1my5y",
  "is-pseudo-focused": "DefaultTheme__is-pseudo-focused___3HZz6",
  "select-input": "DefaultTheme__select-input___2avnv",
  "select-loading-zone": "DefaultTheme__select-loading-zone___WAhzl",
  "select-clear-zone": "DefaultTheme__select-clear-zone___2fi4k",
  "select-arrow-zone": "DefaultTheme__select-arrow-zone___3e32g",
  "select-arrow": "DefaultTheme__select-arrow___Dayiq",
  "select-clear-wrapper": "DefaultTheme__select-clear-wrapper___1ayXZ",
  "select-aria-only": "DefaultTheme__select-aria-only___1gpr1",
  "select-value-label": "DefaultTheme__select-value-label___27p-c",
  "select-value": "DefaultTheme__select-value___BQiRf",
  "select-value-clearable": "DefaultTheme__select-value-clearable___2LpKU",
  "select--multi": "DefaultTheme__select--multi___1T068",
  "select-value-icon": "DefaultTheme__select-value-icon___Z0NY3",
  "select-multi-value-wrapper": "DefaultTheme__select-multi-value-wrapper___3v8iM",
  "select-input-inline": "DefaultTheme__select-input-inline___3hzsy",
  "select-menu-outer": "DefaultTheme__select-menu-outer___364oB",
  "render-in-component": "DefaultTheme__render-in-component___2EwT8",
  "fixed-action": "DefaultTheme__fixed-action___39eNF",
  "select-menu-outer-upwards": "DefaultTheme__select-menu-outer-upwards___179o_",
  "select-menu": "DefaultTheme__select-menu___1Ofcw",
  "select-menu-header": "DefaultTheme__select-menu-header___2ehOS",
  "select-noresults": "DefaultTheme__select-noresults___3l8hJ",
  "select-menu-header-hint": "DefaultTheme__select-menu-header-hint___2gat7",
  "select-option": "DefaultTheme__select-option___2xwWF",
  "is-focused": "DefaultTheme__is-focused___lR404",
  "is-selected": "DefaultTheme__is-selected___2QAek",
  "selectControl": "DefaultTheme__select-control___1Pnw3",
  "hasError": "DefaultTheme__has-error___2pDW6",
  "isSearchable": "DefaultTheme__is-searchable___3iaJ3",
  "isOpen": "DefaultTheme__is-open___3xj30",
  "isDisabled": "DefaultTheme__is-disabled___31xF1",
  "selectPlaceholder": "DefaultTheme__select-placeholder___IC546",
  "hasValue": "DefaultTheme__has-value___1my5y",
  "isPseudoFocused": "DefaultTheme__is-pseudo-focused___3HZz6",
  "selectInput": "DefaultTheme__select-input___2avnv",
  "selectLoadingZone": "DefaultTheme__select-loading-zone___WAhzl",
  "selectClearZone": "DefaultTheme__select-clear-zone___2fi4k",
  "selectArrowZone": "DefaultTheme__select-arrow-zone___3e32g",
  "selectArrow": "DefaultTheme__select-arrow___Dayiq",
  "selectClearWrapper": "DefaultTheme__select-clear-wrapper___1ayXZ",
  "selectAriaOnly": "DefaultTheme__select-aria-only___1gpr1",
  "selectValueLabel": "DefaultTheme__select-value-label___27p-c",
  "selectValue": "DefaultTheme__select-value___BQiRf",
  "selectValueClearable": "DefaultTheme__select-value-clearable___2LpKU",
  "selectMulti": "DefaultTheme__select--multi___1T068",
  "selectValueIcon": "DefaultTheme__select-value-icon___Z0NY3",
  "selectMultiValueWrapper": "DefaultTheme__select-multi-value-wrapper___3v8iM",
  "selectInputInline": "DefaultTheme__select-input-inline___3hzsy",
  "selectMenuOuter": "DefaultTheme__select-menu-outer___364oB",
  "renderInComponent": "DefaultTheme__render-in-component___2EwT8",
  "fixedAction": "DefaultTheme__fixed-action___39eNF",
  "selectMenuOuterUpwards": "DefaultTheme__select-menu-outer-upwards___179o_",
  "selectMenu": "DefaultTheme__select-menu___1Ofcw",
  "selectMenuHeader": "DefaultTheme__select-menu-header___2ehOS",
  "selectNoresults": "DefaultTheme__select-noresults___3l8hJ",
  "selectMenuHeaderHint": "DefaultTheme__select-menu-header-hint___2gat7",
  "selectOption": "DefaultTheme__select-option___2xwWF",
  "isFocused": "DefaultTheme__is-focused___lR404",
  "isSelected": "DefaultTheme__is-selected___2QAek"
};
require("../Select/themes/DarkTheme.css");
var SelectDarkTheme = {
  "select": "DarkTheme__select___34n6G",
  "select-control": "DarkTheme__select-control___3mEL9",
  "select-input": "DarkTheme__select-input___1bIKY",
  "select-value": "DarkTheme__select-value___30BIs",
  "select-value-label": "DarkTheme__select-value-label___lLTL5",
  "has-value": "DarkTheme__has-value___3P5BN",
  "select--single": "DarkTheme__select--single___10lG-",
  "is-pseudo-focused": "DarkTheme__is-pseudo-focused___23OTF",
  "focus-select": "DarkTheme__focus-select___1gIws",
  "is-open": "DarkTheme__is-open___i_gFZ",
  "is-disabled": "DarkTheme__is-disabled___Qunr8",
  "is-searchable": "DarkTheme__is-searchable___1Lca8",
  "select-option": "DarkTheme__select-option___2hAiH",
  "is-focused": "DarkTheme__is-focused___240Mf",
  "is-selected": "DarkTheme__is-selected___102ix",
  "select-menu-outer": "DarkTheme__select-menu-outer___3ArQK",
  "select-menu": "DarkTheme__select-menu___2M4w8",
  "select-menu-header": "DarkTheme__select-menu-header___jwX7g",
  "select-menu-header-hint": "DarkTheme__select-menu-header-hint___fPv1K",
  "select-noresults": "DarkTheme__select-noresults___1wPN8",
  "selectControl": "DarkTheme__select-control___3mEL9",
  "selectInput": "DarkTheme__select-input___1bIKY",
  "selectValue": "DarkTheme__select-value___30BIs",
  "selectValueLabel": "DarkTheme__select-value-label___lLTL5",
  "hasValue": "DarkTheme__has-value___3P5BN",
  "selectSingle": "DarkTheme__select--single___10lG-",
  "isPseudoFocused": "DarkTheme__is-pseudo-focused___23OTF",
  "focusSelect": "DarkTheme__focus-select___1gIws",
  "isOpen": "DarkTheme__is-open___i_gFZ",
  "isDisabled": "DarkTheme__is-disabled___Qunr8",
  "isSearchable": "DarkTheme__is-searchable___1Lca8",
  "selectOption": "DarkTheme__select-option___2hAiH",
  "isFocused": "DarkTheme__is-focused___240Mf",
  "isSelected": "DarkTheme__is-selected___102ix",
  "selectMenuOuter": "DarkTheme__select-menu-outer___3ArQK",
  "selectMenu": "DarkTheme__select-menu___2M4w8",
  "selectMenuHeader": "DarkTheme__select-menu-header___jwX7g",
  "selectMenuHeaderHint": "DarkTheme__select-menu-header-hint___fPv1K",
  "selectNoresults": "DarkTheme__select-noresults___1wPN8"
};
require("../Select/themes/LumeTheme.css");
var SelectLumeTheme = {
  "select": "LumeTheme__select___18MCr",
  "select-option": "LumeTheme__select-option___2H28Z",
  "select-menu": "LumeTheme__select-menu___26aMY",
  "select--multi": "LumeTheme__select--multi___2zU_Z",
  "select-menu-outer": "LumeTheme__select-menu-outer___3VdKI",
  "select-value-label": "LumeTheme__select-value-label___3K5-P",
  "selectOption": "LumeTheme__select-option___2H28Z",
  "selectMenu": "LumeTheme__select-menu___26aMY",
  "selectMulti": "LumeTheme__select--multi___2zU_Z",
  "selectMenuOuter": "LumeTheme__select-menu-outer___3VdKI",
  "selectValueLabel": "LumeTheme__select-value-label___3K5-P"
}; // Empty object because Typeahead doesn't have Lume styles.
var LumeTheme = {};
DefaultTheme.Select = SelectDefaultTheme;
DarkTheme.Select = SelectDarkTheme;
LumeTheme.Select = SelectLumeTheme;
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_TypeAhead["default"].displayName, themes.DefaultTheme)(_TypeAhead["default"]);
ThemedComponent.displayName = _TypeAhead["default"].displayName;
ThemedComponent.themes = themes;
ThemedComponent.isFormComponent = true;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map